module.exports = __webpack_public_path__ + "media/espacio_bellanova.e1516b63.mp4";